// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spaceTop4 {
    margin-top: 24px;
    text-align: center;
}

.rc-pagination {
    font-family: var(--font-family-base);
    list-style-type: none;
    padding-bottom: 50px;
    gap: 8px;
    grid-gap: 8px;
    flex-wrap: wrap;
}

.rc-pagination-total-text {
    position: absolute;
    bottom: 10px;
    margin: 0;
    left: 0px;
    right: 0px;
    color: var(--secondary-foreground);
}

.rc-pagination-item {
    background-color: var(--background-primary);
    border: 1px solid var(--primary-border);
}

.rc-pagination-prev,
.rc-pagination-jump-prev,
.rc-pagination-jump-next,
.rc-pagination-item,
.rc-pagination-next {
    margin-right: 0;
    font-family: var(--font-family-base);
    border-radius: 50%;
}

.rc-pagination-item a,
.rc-pagination-prev span,
.rc-pagination-next span,
.rc-pagination-jump-prev,
.rc-pagination-jump-next {
    color: var(--secondary-foreground);
}

.rc-pagination-item:hover,
.rc-pagination-item:focus {
    border-color: var(--secondary-bg);
}

.rc-pagination-item:hover a,
.rc-pagination-item:focus a {
    color: var(--secondary-bg);
}

.rc-pagination-item-active,
.rc-pagination-item-active:hover,
.rc-pagination-item-active:focus {
    background-color: var(--secondary-bg);
    border-color: var(--secondary-bg);
}

.rc-pagination-item-active a,
.rc-pagination-item-active:hover a,
.rc-pagination-item-active:focus a {
    color: var(--common-primary-white-foreground);
}

.rc-pagination-prev,
.rc-pagination-next {
    border: 1px solid var(--primary-border);
    font-size: 18px;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
}

.rc-pagination-prev span,
.rc-pagination-next span,
.rc-pagination-jump-prev .rc-pagination-jump-custom-icon,
.rc-pagination-jump-next .rc-pagination-jump-custom-icon {
    position: relative;
    top: -1px;
}

.rc-pagination-jump-prev .rc-pagination-jump-custom-icon,
.rc-pagination-jump-next .rc-pagination-jump-custom-icon {
    font-size: 12px;
}

.rc-pagination-jump-afterHover-icon {
    display: none;
}

.rc-pagination-jump-prev:hover .rc-pagination-jump-beforeHover-icon,
.rc-pagination-jump-next:hover .rc-pagination-jump-beforeHover-icon {
    display: none;
}

.rc-pagination-jump-prev:hover .rc-pagination-jump-afterHover-icon,
.rc-pagination-jump-next:hover .rc-pagination-jump-afterHover-icon {
    display: inline-block;
    color: var(--secondary-bg);
}`, "",{"version":3,"sources":["webpack://./src/styles/rc-pagination.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,oBAAoB;IACpB,QAAQ;IACR,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,SAAS;IACT,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;AAC3C;;AAEA;;;;;IAKI,eAAe;IACf,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;;;;;IAKI,kCAAkC;AACtC;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;;IAGI,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;;;IAGI,6CAA6C;AACjD;;AAEA;;IAEI,uCAAuC;IACvC,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;;;IAII,kBAAkB;IAClB,SAAS;AACb;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,qBAAqB;IACrB,0BAA0B;AAC9B","sourcesContent":[".spaceTop4 {\n    margin-top: 24px;\n    text-align: center;\n}\n\n.rc-pagination {\n    font-family: var(--font-family-base);\n    list-style-type: none;\n    padding-bottom: 50px;\n    gap: 8px;\n    grid-gap: 8px;\n    flex-wrap: wrap;\n}\n\n.rc-pagination-total-text {\n    position: absolute;\n    bottom: 10px;\n    margin: 0;\n    left: 0px;\n    right: 0px;\n    color: var(--secondary-foreground);\n}\n\n.rc-pagination-item {\n    background-color: var(--background-primary);\n    border: 1px solid var(--primary-border);\n}\n\n.rc-pagination-prev,\n.rc-pagination-jump-prev,\n.rc-pagination-jump-next,\n.rc-pagination-item,\n.rc-pagination-next {\n    margin-right: 0;\n    font-family: var(--font-family-base);\n    border-radius: 50%;\n}\n\n.rc-pagination-item a,\n.rc-pagination-prev span,\n.rc-pagination-next span,\n.rc-pagination-jump-prev,\n.rc-pagination-jump-next {\n    color: var(--secondary-foreground);\n}\n\n.rc-pagination-item:hover,\n.rc-pagination-item:focus {\n    border-color: var(--secondary-bg);\n}\n\n.rc-pagination-item:hover a,\n.rc-pagination-item:focus a {\n    color: var(--secondary-bg);\n}\n\n.rc-pagination-item-active,\n.rc-pagination-item-active:hover,\n.rc-pagination-item-active:focus {\n    background-color: var(--secondary-bg);\n    border-color: var(--secondary-bg);\n}\n\n.rc-pagination-item-active a,\n.rc-pagination-item-active:hover a,\n.rc-pagination-item-active:focus a {\n    color: var(--common-primary-white-foreground);\n}\n\n.rc-pagination-prev,\n.rc-pagination-next {\n    border: 1px solid var(--primary-border);\n    font-size: 18px;\n    line-height: normal;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.rc-pagination-prev span,\n.rc-pagination-next span,\n.rc-pagination-jump-prev .rc-pagination-jump-custom-icon,\n.rc-pagination-jump-next .rc-pagination-jump-custom-icon {\n    position: relative;\n    top: -1px;\n}\n\n.rc-pagination-jump-prev .rc-pagination-jump-custom-icon,\n.rc-pagination-jump-next .rc-pagination-jump-custom-icon {\n    font-size: 12px;\n}\n\n.rc-pagination-jump-afterHover-icon {\n    display: none;\n}\n\n.rc-pagination-jump-prev:hover .rc-pagination-jump-beforeHover-icon,\n.rc-pagination-jump-next:hover .rc-pagination-jump-beforeHover-icon {\n    display: none;\n}\n\n.rc-pagination-jump-prev:hover .rc-pagination-jump-afterHover-icon,\n.rc-pagination-jump-next:hover .rc-pagination-jump-afterHover-icon {\n    display: inline-block;\n    color: var(--secondary-bg);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
